export default "__VITE_ASSET__BqJ7ElTm__"